import { API as e, Resource as t } from "@coveo/platform-client";
//#region src/resources/OrganizationSettingsResource.ts
var n = class n extends t {
	static {
		this.baseUrl = `/rest/organizations/${e.orgPlaceholder}`;
	}
	getLicenseRestricted() {
		return this.api.get(this.buildPath(`${n.baseUrl}/license/restricted`));
	}
	getAvailableStatementDetails() {
		return this.api.get(this.buildPath(`${n.baseUrl}/definition/statementdetails`));
	}
	getAvailableModifierTemplates() {
		return this.api.get(this.buildPath(`${n.baseUrl}/definition/modifiertemplates`));
	}
	getPlatformFeatureModifiers() {
		return this.api.get(this.buildPath(`${n.baseUrl}/definition/modifiertemplates/platform-feature`));
	}
	enablePlatformFeatureModifier(e) {
		return this.api.put(this.buildPath(`${n.baseUrl}/definition/modifiertemplates/platform-feature/${e}`));
	}
	disablePlatformFeatureModifier(e) {
		return this.api.delete(this.buildPath(`${n.baseUrl}/definition/modifiertemplates/platform-feature/${e}`));
	}
};
//#endregion
export { n as OrganizationSettingsResource };

//# sourceMappingURL=OrganizationSettingsResource.js.map